import { navLinks, siteMeta } from "@/mocks/home";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="px-4 md:px-10 py-12 md:py-16 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
              <i className="ri-fire-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              {siteMeta.name}
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
            {siteMeta.name}
            专注吃瓜资讯聚合与地址发布，实时同步最新更新与维护动态，及时告知失效换地址和新网址，帮你避免吃瓜迷路。
          </p>
          <div className="mt-5 inline-flex items-center gap-2 h-8 px-3 rounded-full bg-primary-950/50 border border-primary-800/60">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-dot" />
            <span className="text-xs text-background-100">
              {siteMeta.statusText} · 更新于 {siteMeta.updatedAt}
            </span>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-medium tracking-wider text-accent-300 uppercase">站内导航</p>
          <ul className="mt-4 space-y-2.5">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs font-medium tracking-wider text-accent-300 uppercase">访问提示</p>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200">
            <li className="flex items-start gap-2">
              <i className="ri-bookmark-line mt-0.5" />
              <span>请收藏本页，而非具体线路地址</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-alert-line mt-0.5" />
              <span>本站入口永久免费，谨防仿冒收费站点</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-refresh-line mt-0.5" />
              <span>打不开先换线路，再回本页核对地址</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800/60 px-4 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-background-200">
          © {year} {siteMeta.name} · 保留所有权利
        </p>
        <p className="text-xs text-background-200">
          本站仅提供信息导航与地址发布，内容以各来源页面为准
        </p>
      </div>
    </footer>
  );
}